export default __webpack_public_path__ + "static/media/bluefish-2.2-is-out.9a21d297.png";